// ========================================
// Flashcard Component
// ========================================
// Versão: 1.0
// Data: 01 de Novembro de 2025

import React, { useState } from 'react';
import './Flashcard.css';

interface FlashcardProps {
  termo: string;
  significado: string;
  descricao?: string;
  dificuldade: number;
  onFlip?: () => void;
}

export default function Flashcard({ 
  termo, 
  significado, 
  descricao, 
  dificuldade, 
  onFlip 
}: FlashcardProps) {
  const [flipped, setFlipped] = useState(false);

  const handleFlip = () => {
    setFlipped(!flipped);
    if (onFlip) {
      onFlip();
    }
  };

  const renderDifficultyStars = () => {
    const stars = '★'.repeat(Math.min(dificuldade, 10));
    return stars;
  };

  return (
    <div 
      className={`flashcard-container ${flipped ? 'flipped' : ''}`}
      onClick={handleFlip}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleFlip();
        }
      }}
      role="button"
      tabIndex={0}
      aria-pressed={flipped}
    >
      <div className="flashcard">
        {/* Frente do card */}
        <div className="flashcard-face flashcard-front">
          <div className="flashcard-header">
            <div className="difficulty-badge">
              <span className="difficulty-stars">{renderDifficultyStars()}</span>
              <span>{dificuldade}/10</span>
            </div>
          </div>
          <div className="flashcard-content">
            <h2>{termo}</h2>
            <p className="hint">Clique para ver a resposta</p>
          </div>
        </div>

        {/* Verso do card */}
        <div className="flashcard-face flashcard-back">
          <div className="flashcard-header">
            <div className="difficulty-badge">
              <span className="difficulty-stars">{renderDifficultyStars()}</span>
              <span>{dificuldade}/10</span>
            </div>
          </div>
          <div className="flashcard-content">
            <h3>Significado:</h3>
            <p className="significado">{significado}</p>
            {descricao && (
              <p className="descricao">{descricao}</p>
            )}
            <p className="hint">Clique para virar</p>
          </div>
        </div>
      </div>
    </div>
  );
}
